<app-header></app-header>
<section class="container-xxl">
  <div class="breadcrumb-area">
    <nav aria-label="breadcrumb mb-0">
        <app-plugin-breadcrumb [datacollection]="{data:P_data,'showEmpMen':showEmpMen,'emp_dtl':emp_dtl}" *ngIf="showBarComponent"></app-plugin-breadcrumb>
      </nav> 
  </div>
  <div class="inner-page-sidedetails">
    <div class="inner-banner-image">
      <div class="image-area">
          <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
      </div>
  </div> 
  <div id="section-New"></div>
    <div class="details">
      <div class="title">
        <h2 class="screen-reader">{{'QuickQuery'| translate}}  </h2>
      </div>
      <div class="description">
        <div class="news mb-3">
          <div class="row">
            <div class="col-lg-12">
              <div class="info-box">
                <div class="row">
                  <div class="col-lg-12">
                    <!-- Contact Wrap Start -->
                <div class="contact-sec">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6">
                            <div class="contact-gap">
                                <!-- Contact Info Start -->
                                <div class="contact-info section-heading">
                                    <ul>
                                        <li>
                                            <!-- Contact Info Item Start -->
                                            <div class="contact-info d-flex align-items-center">
                                                <div class="contact-info-icon">
                                                    <i class="bi bi-person-gear"></i>
                                                </div>
                                                <div class="contact-info-text screen-reader font-adjust">
                                                    <h4 class="title">{{'WebInfoManager'| translate}} </h4>
                                                    <p>
                                                        {{ encDec.decodeHtml(language=='English'?ContactData.webInformationManagerEnglishName:ContactData.webInformationManagerHindiName) }}
                                                    </p>
    
                                                </div>
                                            </div>
                                            <!-- Contact Info Item End -->
                                        </li>

                                        <li>
                                            <!-- Contact Info Item Start -->
                                            <div class="contact-info d-flex align-items-center">
                                                <div class="contact-info-icon">
                                                    <i class="bi bi-phone-vibrate"></i>
                                                </div>
                                                <div class="contact-info-text screen-reader">
                                                    <h4 class="title">{{'ContactNumber'| translate}}</h4>
                                                    <a class=" font-adjust" href="#" [attr.title]="language=='English'?'Phone No.':'फोन नंबर'">
                                                        {{ encDec.decodeHtml(language=='English'?ContactData.contactNumber:ContactData.contactNumber) }}
                                                    </a> 
                                                </div>
                                            </div>
                                            <!-- Contact Info Item End -->
                                        </li>
                                        <li>
                                            <!-- Contact Info Item Start -->
                                            <div class="contact-info d-flex align-items-center">
                                                <div class="contact-info-icon">
                                                    <i class="bi bi-envelope"></i>
                                                </div>
                                                <div class="contact-info-text screen-reader">
                                                    <h4 class="title">{{'OurMail'|translate}}</h4>
                                                    <a class=" font-adjust" [attr.title]="language=='English'?'E-mail':'ई-मेल'" href="{{ encDec.decodeHtml(language=='English'?ContactData.ourMail:ContactData.ourMail) }}" title="E-mail">
                                                        {{ encDec.decodeHtml(language=='English'?ContactData.ourMail:ContactData.ourMail) }}
                                                    </a>
                                                </div>
                                            </div>
                                            <!-- Contact Info Item End -->
                                        </li>

                                        <li>
                                            <!-- Contact Info Item Start -->
                                            <div class="contact-info d-flex align-items-center">
                                                <div class="contact-info-icon">
                                                    <i class="bi bi-globe"></i>
                                                </div>
                                                <div class="contact-info-text screen-reader font-adjust">
                                                    <h4 class="title">{{'Website'|translate}}</h4>
                                                    {{ encDec.decodeHtml(language=='English'?ContactData.website:ContactData.website) }}
                                                </div>
                                            </div>
                                            <!-- Contact Info Item End -->
                                        </li>


                                        <li>
                                            <!-- Contact Info Item Start -->
                                            <div class="contact-info d-flex align-items-center">
                                                <div class="contact-info-icon">
                                                    <i class="bi bi-geo-alt"></i>
                                                </div>
                                                <div class="contact-info-text screen-reader font-adjust">
                                                    <h4 class="title">{{'OurLocation'| translate}}</h4>
                                                    <p>
                                                        {{ encDec.decodeHtml(language=='English'?ContactData.ourLocation:ContactData.ourLocationHindi) }}
                                                    </p>
                                                    <div class="btn-group mt-2">
                                                        <a href="{{siteURL}}contact-directory" [attr.title]="language=='English'?'Go to Contact Directory':'संपर्क निर्देशिका पर जाएँ'" class="btn btn-orange-outline d-flex align-items-center gap-2"><i class="fa fa-link"></i> {{'ContactDirectory'| translate}}</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Contact Info Item End -->
                                        </li>

                                    </ul>
                                </div>
                            </div>
                            <!-- Contact Info End -->
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6">
                            <!-- Contact Form Start -->
                            <div class="contact-form">
                                <div class="contact-form-wrap">
                                    <div class="heading-wrap text-center section-heading">
                                        <h3 class="title screen-reader"> {{'GetInTouch' |translate}} </h3>
                                    </div>
                                    <div class="alert alert-success screen-reader"
                                    style="text-align: center;" role="alert" *ngIf="status">
                                    {{sucess_message}}</div>
                                    <form action="#"  [formGroup]="ContactusForm" (ngSubmit)="submitContactus()">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <!-- Single Form Start -->
                                                <div class="single-form">
                                                    <div class="contact-ic"><i class="bi bi-person"></i> </div>
                                                    <input type="text" placeholder="{{'ContactName' |translate}}" class="form-control screen-reader" name="name" id="name" formControlName="name" autocomplete="off">
                                                    <span class="lab-invalid text-danger screen-reader" *ngIf="name && name.invalid && name.touched">Name field is
                                                        not valid</span>
                                                </div>
                                                <!-- Single Form End -->
                                            </div>

                                            <div class="col-sm-12">
                                                <div class="single-form">
                                                    <div class="contact-ic"><i class="bi bi-envelope-open"></i> </div>
                                                    <input type="email" placeholder="{{'ContactEmail'| translate}}" class="form-control screen-reader" name="email" id="email" formControlName="email" autocomplete="off">
                                                    <span class="lab-invalid text-danger screen-reader" *ngIf="email && email.invalid && email.touched">Email Id field is
                                                        not valid</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <!-- Single Form Start -->
                                                <div class="single-form">
                                                    <div class="contact-ic"><i class="bi bi-pencil"></i> </div>
                                                    <textarea placeholder="{{'Contactcomment' | translate}}"
                                                        class="form-control screen-reader" name="comments" id="comments" formControlName="comments"></textarea>
                                                </div>
                                                <!-- Single Form End -->
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="position-relative">
                                                    <div class="captcha-box">
                                                        <div class="captcha screen-reader">
                                                            <img *ngIf="captchaImgDisplay" src="{{captchaImg}}" id="captchaImage"
                                                            class="mb-0" alt="captcha">
                                                            <a href="javascript:void(0);" class="text-orange" data-bs-toggle="tooltip" [attr.title]="language=='English'?'Refresh Captcha':'कैप्चा रिफ्रेश करें'" (click)="reloadCaptcha()"><i class="bi bi-arrow-clockwise"></i></a>
                                                        </div>
                                                        <div class="single-form mb-0">
                                                            <input type="text" maxlength="50" class="form-control screen-reader" value="" onfocus="this.select();"
                                                            id="captcha" name="captcha" formControlName="captcha" placeholder="{{'EnterCaptcha'|translate}}" autocomplete="off"
                                                            [attr.data-val]="captchaData">
                                                            <span class="lab-invalid text-danger screen-reader" *ngIf="captcha && captcha.invalid && captcha.touched">Captcha is
                                                                not valid</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-sm-12">
                                                <!--  Single Form Start -->
                                                <div class="form-btn">
                                                    <button class="btn btn-3 screen-reader" [attr.title]="language=='English'?'Submit':'जमा करें'" type="submit" [disabled]="ContactusForm.invalid">{{'SendMessage'|translate}}</button>
                                                </div>
                                                <!--  Single Form End -->
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <!-- Contact Form End -->
                        </div>
                    </div>
                </div>
                <!-- Contact Wrap End -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<app-clients></app-clients>

<app-footer></app-footer>